import { Box, Button, List, ListItem } from '@mui/material'
import React from 'react'

export interface SelectedLocation {
  id: number
  name: string
}

interface LocationSelectorProps {
  locations: any[]
  onSelectLocation: (location: SelectedLocation) => void
  onBack: () => void
  loading: boolean
}

const LocationSelector: React.FC<LocationSelectorProps> = ({
  locations,
  onSelectLocation,
  onBack,
  loading
}) => {
  return (
    <>
      <Box sx={{ margin: '20px' }}>
        <Button variant='outlined' onClick={onBack} disabled={loading}>
          Back
        </Button>
      </Box>
      <List
        sx={{
          marginTop: '50px',
          '& .MuiButton-root': {
            width: '100%',
            textAlign: 'center',
            textTransform: 'none',
            fontSize: '26px',
            padding: '50px 20px',
            backgroundColor: '#364c63',
            '&:hover': { backgroundColor: '#456280' }
          }
        }}
      >
        {locations.map((location: any) => (
          <ListItem key={location.id}>
            <Button
              variant='contained'
              onClick={() =>
                onSelectLocation({
                  id: Number(location.id),
                  name: location.name
                })
              }
            >
              {location.name}
            </Button>
          </ListItem>
        ))}
      </List>
    </>
  )
}

export default LocationSelector
